export const homePath = ability => ability.can('view', 'live-feed') ? '/admin/live-feed' : ability.can('view', 'balances') ? '/admin/balances-overview' : '/admin/accounts';
